import { useI18n } from "@/i18n/i18n";

const map = {
  present: "badge-present",
  absent: "badge-absent",
  justified: "badge-justified",
  unjustified: "badge-unjustified",
  unjustified_consumed: "bg-orange-100 text-orange-800 border border-orange-300",
  teacher_cancelled: "bg-slate-200 text-slate-700 border border-slate-300",
  not_counted: "bg-indigo-100 text-indigo-800 border border-indigo-300 border-dashed",
  removed: "bg-slate-50 text-slate-500 border border-dashed border-slate-400 line-through",
  paid: "badge-paid",
  pending: "badge-pending",
};

export function StatusBadge({ status }) {
  const { t } = useI18n();
  const cls = map[status] ?? "bg-slate-100 text-slate-700 border border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-[11px] font-semibold uppercase tracking-wide ${cls}`}
    >
      {t(status)}
    </span>
  );
}
